function log(msg) {
    const requestOptions = {
        method: 'POST',
        body: msg
    };
    // fetch('backend/log', requestOptions);
}
export default log;